function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => { 
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');
  
    if(summary.nextElementSibling?.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
  
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
  
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
  
    removeTrapFocus();
  
    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;
  
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
  
      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
  
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
  
    elementToFocus.focus();
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch(e) {
    focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
  
    window.addEventListener('keydown', (event) => {
      if(navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
  
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
  
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
      if (mouseClick) return;
  
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
  
    }, true);
  }
  
  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  
  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
    if (elementToFocus) elementToFocus.focus();
  }
  
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
  
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })
  
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
  
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }
  
  customElements.define('quantity-input', QuantityInput);
  
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  
  /*
   * Shopify Common JS
   *
   */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  
  Shopify.bind = function(fn, scope) {
    return function() {
      return fn.apply(scope, arguments);
    }
  };
  
  Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };
  
  Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
  };
  
  Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
  
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
  
    for(var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  
  Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));
  
    this.initCountry();
    this.initProvince();
  };
  
  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
      var value = this.countryEl?.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },
  
    initProvince: function() {
      var value = this.provinceEl?.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },
  
    countryHandler: function(e) {
      var opt       = this.countryEl.options[this.countryEl.selectedIndex];
      var raw       = opt?.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);
  
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }
  
        this.provinceContainer.style.display = "";
      }
    },
  
    clearOptions: function(selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },
  
    setOptions: function(selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    }
  };
  
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.mainDetailsToggle = this.querySelector('details');
  
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
  
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
  
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
  
      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;

      
      this.mainDetailsToggle.classList.remove('menu-opening');
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  
    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  
    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
  
      window.requestAnimationFrame(handleAnimation);
    }
  }
  
  customElements.define('menu-drawer', MenuDrawer);
  
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
  
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.getElementById('shopify-section-header');
      if (this.header !== null) {
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        this.header.classList.add('menu-open');
      }
      
  
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
  
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      if (this.header !== null) {
        this.header.classList.remove('menu-open');
      }
    }
  }
  
  customElements.define('header-drawer', HeaderDrawer);
  
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        });
      }
    }
  
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
  
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
      if (this.classList.contains('product-media-modal')) {
        this.showActiveMedia();
      }
    }
  
    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
  
      const button = this.querySelector('button');
  
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this?.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  
    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this?.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
      }
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);
  
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
  
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
  
      if (this.enableSliderLooping) return;
  
      if (this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  
  customElements.define('slider-component', SliderComponent);
  
  class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
  
      if (!this.sliderControlWrapper) return;
  
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
  
      if (this.slider?.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
  
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
  
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
  
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  
    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
      if (!isFirstSlide && !isLastSlide) return;
  
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');
  
      if (!this.sliderControlButtons.length) return;
  
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  
    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
  
    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
  
    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
  
    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  
    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
  
    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
  
    autoRotateSlides() {
      const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  
    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const button = item.querySelector('a');
        if (index === this.currentPage - 1) {
          if (button) button.removeAttribute('tabindex');
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (button) button.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
  
    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  
  customElements.define('slideshow-component', SlideshowComponent);
  
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
      this.isGiftCardProduct = document.querySelector('[data-product-type]')?.dataset.productType === 'Gift Card';
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
      if (this.isGiftCardProduct) {
        this.updateMobileCarousel();
      }
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
  
      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
  
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent?.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent?.prepend(newMediaModal);
    }
  
    updateMobileCarousel() {
      const carousel = document.querySelector('.custom-product-images-carousel.owl-carousel');
      if (!carousel || !this.currentVariant?.featured_media) return;
  
      const imageSrc = this.currentVariant.featured_media.preview_image?.src || this.currentVariant.featured_media.src;
      const imageAlt = this.currentVariant.featured_media.alt || this.currentVariant.title;
  
      const activeSlide = carousel.querySelector('.owl-item.active.center');
  
      if (!activeSlide) return;
  
      const img = activeSlide.querySelector('img');
      if (img) {
        img.src = `${imageSrc}&width=1000`;
        img.alt = imageAlt;
      }
  
      const video = activeSlide.querySelector('video');
      if (video) {
        const source = video.querySelector('source');
        if (source) {
          const newVideoUrl = this.currentVariant.featured_media.sources?.[1]?.url || this.currentVariant.featured_media.sources?.[0]?.url;
          source.src = newVideoUrl;
          video.load(); 
        }
        video.poster = imageSrc;
      }
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${location.pathname}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      fetch(`${location.pathname}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `price-${this.dataset.section}`;
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
  
          const price = document.getElementById(`price-${this.dataset.section}`);
  
          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"]');
      const productTag = productForm.getAttribute('pd_tag');
  
      if (!addButton) return;
  
      if (productTag === 'pre-order') {
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = "PRE ORDER";
        }
      } else {
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = "ADD TO CART";
        }
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"]');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = "UNAVAILABLE";
      if (price) price.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = JSON.parse(this.querySelector('[data-product-variants]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const radio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        if (radio && radio.hasAttribute('data-inventory-count')) {
          this.stockAlert(radio.getAttribute('data-inventory-count'));
        }
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  
    stockAlert(stockCount) {
      const stockAlert = document.querySelector('.stock-alert');
      if (stockCount < 10) {
        stockAlert.querySelector('span').textContent = `Last ${stockCount} remaining in this size`;
        stockAlert.style.display = 'block';
      }else{
        stockAlert.style.display = 'none';
      }
    }
  }
  
  customElements.define('variant-radios', VariantRadios);
  
  const SIZE_CONVERSION_DEFAULTS = Object.freeze({
    eu: 34,
    us: 1
  });
  
  class VariantPicker {
    constructor() {
      this.variantPickerTriggers = document.querySelectorAll('.card_variant_picker_trigger');
      this.quickViewCustomerTiers = document.querySelectorAll('.quick-link__card-info');
      this.quickViewCustomerTierCloses = document.querySelectorAll('button.close-quick-info');
      this.init();
    }
  
    init() {
      this.variantPickerTriggers.forEach(trigger => {
        trigger.addEventListener('click', this.onVariantPickerClick.bind(this));
      });
  
      this.quickViewCustomerTiers.forEach(tier => {
        tier.addEventListener('click', this.onQuickViewCustomerTierClick.bind(this));
      });
  
      this.quickViewCustomerTierCloses.forEach(close => {
        close.addEventListener('click', this.onQuickViewCustomerTierCloseClick.bind(this));
      });
  
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }
  
    onVariantPickerClick(event) {
      event.preventDefault();
      event.stopPropagation();
  
      this.removeExistingVariantPickers();
  
      const trigger = event.currentTarget;
      const scriptJson = trigger.querySelector('script[type="application/json"]').innerHTML;
      const product = JSON.parse(scriptJson).product;
      const productCardContainer = trigger.closest('.card__inner');
      const productCardVariants = this.createProductCardVariants(product);
  
  
      if (window.innerWidth > 1024) {
        productCardContainer.appendChild(productCardVariants);
        productCardContainer.classList.add('product-card-variants--open');
      } else {
        const modal = document.getElementById('product_card_variant_modal');
        modal.classList.add('active');
        modal.appendChild(productCardVariants);
        document.body.classList.add('overflow-hidden');
      }
  
      this.addVariantPickerEventListeners(productCardVariants, trigger, productCardContainer);
    }
  
    removeExistingVariantPickers() {
      document.querySelectorAll('.product-card-variants').forEach(element => {
        element.remove();
        document.querySelectorAll('.card__inner').forEach(card => {
          card.classList.remove('product-card-variants--open');
        });
        document.body.classList.remove('overflow-hidden');
      });
    }
  
    createProductCardVariants(product) {
      const productCardVariants = document.createElement('div');
      productCardVariants.classList.add('product-card-variants');
  
      const rawSc = product.size_conversion;
      const conversionSource =
        rawSc &&
        typeof rawSc === 'object' &&
        !Array.isArray(rawSc)
          ? rawSc
          : {};
      const parseConversionOffset = (value, fallback) => {
        if (value === null || value === undefined || value === '') {
          return fallback;
        }
        const number = Number(value);
        return Number.isFinite(number) ? number : fallback;
      };
  
      const conversionOffsets = {
        eu: parseConversionOffset(conversionSource.eu_offset, SIZE_CONVERSION_DEFAULTS.eu),
        us: parseConversionOffset(conversionSource.us_offset, SIZE_CONVERSION_DEFAULTS.us)
      };
  
      const escapeAttributeValue = (value) => {
        if (value === null || value === undefined) return '';
        return String(value).replace(/"/g, '&quot;');
      };
  
      const escapeHtml = (value) => {
        if (value === null || value === undefined) return '';
        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      };
  
      const regionConfigs = [
        { key: 'uk', label: 'UK' },
        { key: 'eu', label: 'EU' },
        { key: 'us', label: 'US' }
      ];
  
      const formatSizeValue = (value) => {
        if (value === null || value === undefined || value === '') return '';
        const numeric = Number(value);
        if (Number.isNaN(numeric)) return String(value);
        return Number.isInteger(numeric) ? `${numeric}` : numeric.toFixed(1).replace(/\.0$/, '');
      };
  
      const extractUkSize = (variant) => {
        const sources = [];
        if (Array.isArray(variant.options)) {
          sources.push(...variant.options);
        }
        if (variant.title) sources.push(variant.title);
        if (variant.sku) sources.push(variant.sku);
  
        const ukMatch = sources.join(' | ').match(/UK[\s:-]*([0-9]+(?:\.[0-9])?)/i);
        if (ukMatch) return ukMatch[1];
  
        const titleParts = String(variant.title || '').split(' / ');
        const candidate = titleParts[titleParts.length - 1] || '';
        const numericMatch = candidate.match(/([0-9]+(?:\.[0-9])?)/);
        if (numericMatch) return numericMatch[1];
  
        return '';
      };
  
      const buildSizeLabels = (variant) => {
        const ukSize = extractUkSize(variant);
        const defaultTitle = String(variant.title || '').split(' / ').pop() || '';
        const values = { uk: '', eu: '', us: '' };
  
        if (!ukSize) {
          return {
            values,
            defaultLabel: defaultTitle
          };
        }
  
        const numericUk = Number(ukSize);
        const hasNumericUk = !Number.isNaN(numericUk);
  
        const formattedUk = formatSizeValue(ukSize);
        values.uk = formattedUk;
  
        if (hasNumericUk) {
          const euValue = formatSizeValue(numericUk + conversionOffsets.eu);
          const usValue = formatSizeValue(numericUk + conversionOffsets.us);
          values.eu = euValue;
          values.us = usValue;
        }
  
        return {
          values,
          defaultLabel: formattedUk || defaultTitle
        };
      };
  
      const productVariants = Array.isArray(product.variants) ? product.variants : [];
      const firstAvailableVariantId = productVariants.find((variant) => variant?.available)?.id;
      const firstAvailableVariant = productVariants.find((variant) => variant?.available);
      const selectedVariant = productVariants.find((variant) => variant.id === product.selected_variant_id) || firstAvailableVariant;
  
      // Function to determine button text based on product tags and availability
      const getButtonText = () => {
        const productTags = Array.isArray(product.tags) ? product.tags : [];
        const soldOutText = window.variantStrings?.soldOut || 'SOLD OUT';
        const addToCartText = window.variantStrings?.addToCart || 'ADD TO CART';
  
        // Check if product has 'sold-out' tag
        if (productTags.includes('sold-out')) {
          // Check for restock date
          const restockTag = productTags.find(tag => tag && tag.includes('restock:'));
          if (restockTag) {
            const restockDate = restockTag.split('restock:').pop().trim();
            return `${soldOutText} - RESTOCK ${restockDate}`;
          }
          return soldOutText;
        }
        
        // Check if selected/first available variant is not available
        if (selectedVariant && !selectedVariant.available) {
          return soldOutText;
        }
        
        // Check if product has 'pre-order' tag
        if (productTags.includes('pre-order')) {
          return 'PRE ORDER';
        }
        
        // Default to add to cart
        return addToCartText;
      };
  
      const buttonText = getButtonText();
  
      const variantOptionsMarkup = productVariants.map((variant) => {
        const sizeData = buildSizeLabels(variant);
        const optionClasses = [
          'option',
          !variant.available ? 'unavailable' : '',
          variant.available && variant.id === firstAvailableVariantId ? 'selected' : ''
        ].filter(Boolean).join(' ');
  
        const regionDataAttrs = regionConfigs.map((region) => {
          const value = sizeData.values[region.key] || '';
          return ` data-size-${region.key}="${escapeAttributeValue(value)}"`;
        }).join('');
  
        const fallbackLabel = sizeData.defaultLabel;
  
        return `
                    <div class="${optionClasses}" data-value="${escapeAttributeValue(variant.id)}"${regionDataAttrs} data-default-label="${escapeAttributeValue(fallbackLabel)}">${escapeHtml(fallbackLabel)}</div>
                  `;
      }).join('');
  
      const regionSelectorMarkup = `
        <div class="pcv_variant_selector__regions">
          ${regionConfigs.map((region, index) => `<button type="button" class="pcv_variant_selector__region${index === 0 ? ' active' : ''}" data-region="${escapeAttributeValue(region.key)}">${region.label}</button>`).join('')}
        </div>
      `;
  
      const defaultRegion = regionConfigs[0].key;
      const defaultRegionAttr = ` data-default-region="${escapeAttributeValue(defaultRegion)}"`;
  
      productCardVariants.innerHTML = `
      <button class="product-card-variants__close product-card-variant__outerclose">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
            </svg>
          </button>
        <div class="product-card-variants__header">
          <div class="pcv_product__image"><img src="${product.featured_image}" alt="${product.title}"></div>
          <div class="pcv_product__title">
            <a href="/products/${product.handle}">
              <span class="product_model">${product.model}</span>
              <span class="product_colour">${product.colour}</span>
            </a>
            <div class="product-card-variants__other_colours">
              <div class="colour-box">${this.createColourBox(product.colour_box)}</div>
                <span>${(parseInt(product.other_colour_count, 10) || 0) - 1 > 0
                  ? `${(parseInt(product.other_colour_count, 10) || 0) - 1} other colours`
                  : 'no other colours'}
                </span>
            </div>
            <div class="product-card-variants__price">
              <span class="pcv_product_compare_price">${product.compare_at_price}</span>
              <span class="pcv_product_final_price">${product.price}</span>
            </div>
            <a class="product-card-url" href="/products/${product.handle}">More Details<svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
    <path d="M11.9314 3.03064L0.399902 3.03064" stroke="#131313" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.76904 5.66125L12.3997 3.03062L9.76904 0.399994" stroke="#131313" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg></a>
          </div>
          <button class="product-card-variants__close">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
        <div class="product-card-variants__body">
          <div class="product-card-variants__options">
            <div class="product-card-variants__variants">
            ${product.variants.length > 1 ? `
              <div class="pcv_variant_selector"${defaultRegionAttr}>
                <div class="pcv_variant_selector__header">
                  ${product.customer_card_small ? `<div class="pcv_variant_selector__earnpoints"><img src="${product.customer_card_small}"><span class="points-text">Earn ${product.points_to_earn} Points</span></div>` : ''}
                </div>
                ${regionSelectorMarkup}
                <div class="pcv_variant_selector__options">
                  ${variantOptionsMarkup}
                </div>
              </div>
              `
              : ''}
              <button class="card_add_to_cart" data-selected-variant="${product.selected_variant_id}">${escapeHtml(buttonText)}</button>
            </div>
          </div>
          <div class="product-card-variants__link">
            <a href="/products/${product.handle}">more details</a>
          </div>
        </div>
      `;
  
      const selector = productCardVariants.querySelector('.pcv_variant_selector');
      if (selector && defaultRegion) {
        selector.dataset.defaultRegion = defaultRegion;
      }
  
      // Store product data for later use (for updating button text on variant change)
      productCardVariants.dataset.productTags = JSON.stringify(product.tags || []);
      productCardVariants.dataset.productVariants = JSON.stringify(productVariants);
  
      return productCardVariants;
    }
  
    createColourBox(colourBox) {
      if (!colourBox) return '<span style="background-color: #E8E6E7;"></span>';
      return colourBox.map(color => `<span style="background-color: ${color};"></span>`).join('');
    }
  
    addVariantPickerEventListeners(productCardVariants, trigger, productCardContainer) {
      productCardVariants.querySelector('.product-card-variants__close').addEventListener('click', () => {
        productCardVariants.remove();
        productCardContainer.classList.remove('product-card-variants--open');
        document.body.classList.remove('overflow-hidden');
      });
  
      document.addEventListener('click', event => {
        if (!productCardContainer.contains(event.target)) {
          productCardVariants.remove();
          productCardContainer.classList.remove('product-card-variants--open');
          document.body.classList.remove('overflow-hidden');
        }
      }, { once: true });
  
      productCardVariants.addEventListener('click', event => {
        event.stopPropagation();
      });
  
      productCardVariants.querySelector('.card_add_to_cart').addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        this.addToCart(productCardVariants);
      });
  
      productCardVariants.querySelectorAll('.option').forEach(option => {
        option.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.selectVariant(option, productCardVariants);
        });
      });
  
      const regionButtons = productCardVariants.querySelectorAll('.pcv_variant_selector__region');
      if (regionButtons.length) {
        regionButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const selectedRegion = button.dataset.region;
            regionButtons.forEach((btn) => {
              btn.classList.toggle('active', btn === button);
            });
            this.updateRegionDisplay(productCardVariants, selectedRegion);
          });
        });
  
        const selector = productCardVariants.querySelector('.pcv_variant_selector');
        const defaultRegion = selector?.dataset?.defaultRegion || regionButtons[0].dataset.region;
        regionButtons.forEach((button) => {
          button.classList.toggle('active', button.dataset.region === defaultRegion);
        });
        this.updateRegionDisplay(productCardVariants, defaultRegion);
      } else {
        this.updateRegionDisplay(productCardVariants, null);
      }
    }
  
    updateRegionDisplay(productCardVariants, region) {
      const selector = productCardVariants.querySelector('.pcv_variant_selector');
      if (!selector) return;
  
      const optionElements = selector.querySelectorAll('.pcv_variant_selector__options .option');
      const datasetKey = region ? `size${region.charAt(0).toUpperCase()}${region.slice(1)}` : null;
  
      optionElements.forEach((option) => {
        if (!datasetKey) {
          option.textContent = option.dataset.defaultLabel || option.textContent;
          return;
        }
  
        const regionValue = option.dataset[datasetKey];
        const fallbackLabel = option.dataset.defaultLabel || '';
        option.textContent = regionValue || fallbackLabel;
      });
  
      if (region) {
        selector.dataset.activeRegion = region;
      } else {
        selector.removeAttribute('data-active-region');
      }
    }
  
    addToCart(productCardVariants) {
      const variantId = productCardVariants.querySelector('.card_add_to_cart').getAttribute('data-selected-variant');
      const quantity = 1;
      const isMobile = window.innerWidth <= 1024;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity })
      })
      .then(response => response.json())
      .then(() => {
        this.reRenderDrawer();

        setTimeout(() => {
          productCardVariants.remove();
          document.body.classList.remove('overflow-hidden');
          
          if (isMobile) {
            const modal = document.getElementById('product_card_variant_modal');
            if (modal) {
              modal.classList.remove('active');
            }
          }
          
          this.openDrawer();
        }, 500);
      })
      .catch(error => console.error('Error:', error));
    }
  
    selectVariant(option, productCardVariants) {
      if (!option.classList.contains('unavailable')) {
        const selectedVariantId = option.getAttribute('data-value');
        const button = productCardVariants.querySelector('.card_add_to_cart');
        button.setAttribute('data-selected-variant', selectedVariantId);
        
        // Update button text based on selected variant
        const productTags = JSON.parse(productCardVariants.dataset.productTags || '[]');
        const productVariants = JSON.parse(productCardVariants.dataset.productVariants || '[]');
        const selectedVariant = productVariants.find(v => String(v.id) === String(selectedVariantId));
        
        const soldOutText = window.variantStrings?.soldOut || 'SOLD OUT';
        const addToCartText = window.variantStrings?.addToCart || 'ADD TO CART';
        
        let newButtonText = addToCartText;
        
        // Check if product has 'sold-out' tag
        if (productTags.includes('sold-out')) {
          const restockTag = productTags.find(tag => tag && tag.includes('restock:'));
          if (restockTag) {
            const restockDate = restockTag.split('restock:').pop().trim();
            newButtonText = `${soldOutText} - RESTOCK ${restockDate}`;
          } else {
            newButtonText = soldOutText;
          }
        } else if (selectedVariant && !selectedVariant.available) {
          // Check if selected variant is not available
          newButtonText = soldOutText;
        } else if (productTags.includes('pre-order')) {
          // Check if product has 'pre-order' tag
          newButtonText = 'PRE ORDER';
        }
        
        button.textContent = newButtonText;
        
        productCardVariants.querySelectorAll('.option').forEach(opt => {
          opt.classList.remove('selected');
        });
        option.classList.add('selected');
      }
    }
  
    onQuickViewCustomerTierClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const tier = event.currentTarget;
      tier.nextElementSibling.classList.toggle('active');
      if (window.innerWidth < 990) {
        document.querySelector('.site_modal_overlay').style.display = 'block';
      }
  
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class' && !mutation.target.classList.contains('active')) {
            document.querySelector('.site_modal_overlay').style.display = 'none';
          }
        });
      });
  
      observer.observe(tier.nextElementSibling, { attributes: true });
    }
  
    onQuickViewCustomerTierCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      event.currentTarget.closest('.customer-card-quick-info').classList.remove('active');
    }
  
    onDocumentClick(event) {
      this.quickViewCustomerTiers.forEach(tier => {
        if (!tier.contains(event.target) && !tier.nextElementSibling.contains(event.target)) {
          tier.nextElementSibling.classList.remove('active');
          document.querySelector('.site_modal_overlay').style.display = 'none';
        }
      });
    }
  
    reRenderDrawer() {
      RE_RENDER_DRAWER();
    }
  
    openDrawer() {
      OPEN_DRAWER();
    }
  }

  if (!customElements.get('twa-variant-drawer-picker')) {
    customElements.define(
      'twa-variant-drawer-picker',
      class VariantDrawerPicker extends HTMLElement {
        constructor() {
          super();
          this._drawerContentPromise = null;
          this._onOpenClick = this._onOpenClick.bind(this);
          this._onCloseClick = this._onCloseClick.bind(this);
          this._onDrawerAddToCartClick =
            this._onDrawerAddToCartClick.bind(this);
        }

        connectedCallback() {
          if (
            this.dataset.footwearDrawer === 'true' &&
            this._footwearOriginHandle == null
          ) {
            this._footwearOriginHandle =
              this.dataset.initialProductHandle || '';
            this._footwearOriginProductId =
              this.dataset.initialProductId || '';
          }
          if (
            this.dataset.clothingDrawer === 'true' &&
            this._clothingOriginHandle == null
          ) {
            this._clothingOriginHandle =
              this.dataset.initialProductHandle || '';
            this._clothingOriginProductId =
              this.dataset.initialProductId || '';
          }
          this._bindTriggers();
        }

        disconnectedCallback() {
          this._unbindFootwearDrawer();
          this._unbindClothingDrawer();
          this._unbindTriggers();
          this._unbindProductMediaDragScroll();
        }

        _bindTriggers() {
          this.querySelectorAll('[data-atc-trigger]').forEach((trigger) => {
            trigger.addEventListener('click', this._onOpenClick);
          });
          this.querySelectorAll('[data-drawer-close]').forEach((btn) => {
            btn.addEventListener('click', this._onCloseClick);
          });
          const overlay = this.querySelector('.twa-variant__drawer-overlay');
          if (overlay) {
            overlay.addEventListener('click', this._onCloseClick);
          }
          const atc = this.querySelector('[data-add-to-cart]');
          if (atc) {
            atc.addEventListener('click', this._onDrawerAddToCartClick);
          }
        }

        _unbindTriggers() {
          this.querySelectorAll('[data-atc-trigger]').forEach((trigger) => {
            trigger.removeEventListener('click', this._onOpenClick);
          });
          this.querySelectorAll('[data-drawer-close]').forEach((btn) => {
            btn.removeEventListener('click', this._onCloseClick);
          });
          const overlay = this.querySelector('.twa-variant__drawer-overlay');
          if (overlay) {
            overlay.removeEventListener('click', this._onCloseClick);
          }
          const atc = this.querySelector('[data-add-to-cart]');
          if (atc) {
            atc.removeEventListener('click', this._onDrawerAddToCartClick);
          }
        }

        _onDrawerAddToCartClick(event) {
          event.preventDefault();
          event.stopPropagation();
          const btn = event.currentTarget;
          const variantId = btn.getAttribute('data-product-id');
          if (!variantId || btn.disabled) {
            return;
          }
          if (btn.classList.contains('is-loading')) {
            return;
          }
          const prevText = btn.textContent;
          const loadingLabel =
            btn.getAttribute('data-atc-loading-label') || 'Adding…';
          const endAtcRequest = (success) => {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.textContent = prevText;
            if (success) {
              btn.disabled = false;
              return;
            }
            if (this.dataset.footwearDrawer === 'true') {
              this._updateFootwearSelectionFromRadios();
            } else if (this.dataset.clothingDrawer === 'true') {
              this._updateClothingSelectionFromRadios();
            } else {
              btn.disabled = false;
            }
          };
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;
          btn.textContent = loadingLabel;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1,
            }),
          })
            .then(async (response) => {
              const data = await response.json().catch(() => ({}));
              if (!response.ok) {
                const msg =
                  data.description ||
                  data.message ||
                  'Cart request failed';
                throw new Error(msg);
              }
              return data;
            })
            .then(() => {
              endAtcRequest(true);
              if (typeof RE_RENDER_DRAWER === 'function') {
                RE_RENDER_DRAWER();
              }
              setTimeout(() => {
                if (typeof OPEN_DRAWER === 'function') {
                  OPEN_DRAWER();
                }
                this.classList.remove('twa-variant__drawer-open');
                document.body.style.overflow = '';
              }, 400);
            })
            .catch((err) => {
              console.error('Drawer add to cart:', err);
              endAtcRequest(false);
            });
        }

        async _onOpenClick(event) {
          event.preventDefault();
          event.stopPropagation();
          this.classList.add('twa-variant__drawer-open');
          document.body.style.overflow = 'hidden';
          const contentLoaded = await this._ensureDrawerContentLoaded();
          if (!contentLoaded) {
            return;
          }
          this._loadDeferredDrawerImages();
          this._bindProductMediaDragScroll();
          if (this.dataset.footwearDrawer === 'true') {
            await this._maybeInitFootwearDrawer();
            await this._onFootwearDrawerOpened();
          }
          if (this.dataset.clothingDrawer === 'true') {
            await this._maybeInitClothingDrawer();
            await this._onClothingDrawerOpened();
          }
        }

        async _ensureDrawerContentLoaded() {
          if (this.dataset.drawerContentLoaded === 'true') {
            return true;
          }
          if (this._drawerContentPromise) {
            return this._drawerContentPromise;
          }

          const handle = String(this.dataset.initialProductHandle || '').trim();
          if (!handle) {
            return false;
          }

          this._drawerContentPromise = (async () => {
            const loaded = await this._swapDrawerProductdetailsViaView(handle);
            if (loaded) {
              this.dataset.drawerContentLoaded = 'true';
              return true;
            }

            const loading = this.querySelector('[data-drawer-loading]');
            if (loading) {
              loading.setAttribute('aria-busy', 'false');
            }
            const fallback = this.querySelector('[data-drawer-loading-fallback]');
            if (fallback) {
              fallback.hidden = false;
            }
            return false;
          })();

          const loaded = await this._drawerContentPromise;
          if (!loaded) {
            this._drawerContentPromise = null;
          }
          return loaded;
        }

        _loadDeferredDrawerImages() {
          this.querySelectorAll('img[data-deferred-drawer-image]').forEach(
            (image) => {
              if (image.dataset.srcset) {
                image.srcset = image.dataset.srcset;
              }
              if (image.dataset.src) {
                image.src = image.dataset.src;
              }
              image.removeAttribute('data-srcset');
              image.removeAttribute('data-src');
              image.removeAttribute('data-deferred-drawer-image');
            }
          );
        }

        /**
         * Re-sync labels, region text, and ATC after open so behaviour matches
         * post–colour-switch once JSON prime and option matching have finished.
         * If the shopper changed colour then closed, restore the card product.
         */
        async _onFootwearDrawerOpened() {
          const origin = this._footwearOriginHandle || '';
          const current = this.dataset.initialProductHandle || '';
          if (origin && current && current !== origin) {
            this._footwearCachedProduct = null;
            this.dataset.initialProductHandle = origin;
            if (this._footwearOriginProductId) {
              this.dataset.initialProductId = this._footwearOriginProductId;
            }
            await this._switchFootwearProductByHandle(origin, null);
            return;
          }
          await this._primeFootwearCachedProduct();
          const p = this._footwearCachedProduct;
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          if (!p || !footwear) {
            return;
          }
          this._applyFootwearLabelDatasetsFromVariants(p);
          const activeBtn = footwear.querySelector(
            '.twa-product__size-region-switcher-button.twa-region_active'
          );
          const reg =
            activeBtn && activeBtn.dataset.region
              ? activeBtn.dataset.region
              : 'uk';
          this._syncFootwearSizeRegionLabels(reg);
          this._updateFootwearSelectionFromRadios();
        }

        /**
         * Clothing drawer: restore card product if needed, then prime JSON and
         * sync size row + ATC (parallel to footwear, without region switcher).
         */
        async _onClothingDrawerOpened() {
          const origin = this._clothingOriginHandle || '';
          const current = this.dataset.initialProductHandle || '';
          if (origin && current && current !== origin) {
            this._clothingCachedProduct = null;
            this.dataset.initialProductHandle = origin;
            if (this._clothingOriginProductId) {
              this.dataset.initialProductId = this._clothingOriginProductId;
            }
            await this._switchClothingProductByHandle(origin, null);
            return;
          }
          await this._primeClothingCachedProduct();
          const p = this._clothingCachedProduct;
          const clothing = this.querySelector('.twa-product__swatch-clothing');
          if (!p || !clothing) {
            return;
          }
          this._updateClothingSelectionFromRadios();
        }

        _onCloseClick(event) {
          event.preventDefault();
          event.stopPropagation();
          this.classList.remove('twa-variant__drawer-open');
          document.body.style.overflow = '';
        }

        /**
         * Horizontal strip: overflow scroll + click-drag (grab cursor).
         */
        _bindProductMediaDragScroll() {
          const el = this.querySelector('.twa-variant__drawer-productmedia');
          if (!el || this._productMediaDragBound) {
            return;
          }
          this._productMediaDragBound = true;

          let startX = 0;
          let startScroll = 0;
          let dragActive = false;

          const onPointerDown = (e) => {
            if (!e.isPrimary || e.button !== 0) {
              return;
            }
            dragActive = true;
            startX = e.clientX;
            startScroll = el.scrollLeft;
            el.classList.add('twa-variant__drawer-productmedia--dragging');
            try {
              el.setPointerCapture(e.pointerId);
            } catch (_err) {
              /* ignore */
            }
          };

          const onPointerMove = (e) => {
            if (!e.isPrimary || !dragActive) {
              return;
            }
            const dx = e.clientX - startX;
            el.scrollLeft = startScroll - dx;
          };

          const endDrag = (e) => {
            dragActive = false;
            el.classList.remove('twa-variant__drawer-productmedia--dragging');
            if (e && e.pointerId != null) {
              try {
                if (el.hasPointerCapture(e.pointerId)) {
                  el.releasePointerCapture(e.pointerId);
                }
              } catch (_err) {
                /* ignore */
              }
            }
          };

          el.addEventListener('pointerdown', onPointerDown);
          el.addEventListener('pointermove', onPointerMove);
          el.addEventListener('pointerup', endDrag);
          el.addEventListener('pointercancel', endDrag);

          this._productMediaDragCleanup = () => {
            el.removeEventListener('pointerdown', onPointerDown);
            el.removeEventListener('pointermove', onPointerMove);
            el.removeEventListener('pointerup', endDrag);
            el.removeEventListener('pointercancel', endDrag);
            this._productMediaDragBound = false;
            this._productMediaDragCleanup = null;
          };
        }

        async _maybeInitFootwearDrawer() {
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          if (!footwear || this.dataset.footwearDrawer !== 'true') {
            return;
          }
          if (this._footwearDrawerBound) {
            return;
          }
          this._footwearDrawerBound = true;
          this._onFootwearDrawerClick = (e) => {
            this._handleFootwearDrawerClick(e);
          };
          this._onFootwearDrawerChange = (e) => {
            this._handleFootwearDrawerChange(e);
          };
          this.addEventListener('click', this._onFootwearDrawerClick);
          this.addEventListener('change', this._onFootwearDrawerChange);
          await this._primeFootwearCachedProduct();
          if (this._footwearCachedProduct) {
            this._applyFootwearLabelDatasetsFromVariants(
              this._footwearCachedProduct
            );
            const p = this._footwearCachedProduct;
            const soldOut = this._footwearHasProductTag(p, 'sold-out');
            const v =
              (p.variants || []).find(
                (x) => !this._footwearVariantExplicitlyUnavailable(x) && !soldOut
              ) ||
              (p.variants || [])[0];
            if (v) {
              this._syncDrawerAtcButtonState(p, v);
            }
          }
          void this._hydrateFootwearSwatchesFromCollection();
          this._syncFootwearSizeRegionLabels('uk');
        }

        _syncDrawerAtcButtonState(product, variant) {
          const btn = this.querySelector('[data-add-to-cart]');
          if (!btn || !variant) {
            return;
          }
          const tags = this._footwearTagList(product);
          const soldOutText = window.variantStrings?.soldOut || 'SOLD OUT';
          const addText =
            window.variantStrings?.addToCart || 'ADD TO CART';
          let text = addText;
          let disabled = false;
          if (tags.includes('sold-out')) {
            disabled = true;
            text = soldOutText;
          } else if (this._footwearVariantExplicitlyUnavailable(variant)) {
            disabled = true;
            text = soldOutText;
          } else if (tags.includes('pre-order')) {
            text = 'PRE ORDER';
          }
          btn.textContent = text;
          btn.disabled = !!disabled;
        }

        /**
         * Shows loading chrome on the footwear colour swatch strip (hydrate or
         * colour switch).
         *
         * @param {HTMLElement | null} list
         * @param {boolean} isLoading
         */
        _setFootwearSwatchListLoading(list, isLoading) {
          if (!list) {
            return;
          }
          list.classList.toggle(
            'twa-footwear-swatch-list--loading',
            !!isLoading
          );
          if (isLoading) {
            list.setAttribute('aria-busy', 'true');
          } else {
            list.removeAttribute('aria-busy');
          }
          list.querySelectorAll('button[data-color-switcher]').forEach((b) => {
            b.disabled = !!isLoading;
          });
        }

        /**
         * Shopify /products/{handle}.json returns `tags` as a comma-separated
         * string; treat both string and array shapes for exact tag checks.
         */
        _footwearTagList(product) {
          const raw = product && product.tags;
          if (Array.isArray(raw)) {
            return raw
              .map((t) => String(t).trim().toLowerCase())
              .filter(Boolean);
          }
          if (typeof raw === 'string') {
            return raw
              .split(',')
              .map((t) => t.trim().toLowerCase())
              .filter(Boolean);
          }
          return [];
        }

        _footwearHasProductTag(product, needle) {
          const n = String(needle).trim().toLowerCase();
          return this._footwearTagList(product).includes(n);
        }

        /**
         * Only treat as unavailable when Shopify explicitly says so; missing
         * `available` must not flip the button to sold out.
         */
        _footwearVariantExplicitlyUnavailable(variant) {
          if (!variant) {
            return true;
          }
          if (variant.available === false) {
            return true;
          }
          if (variant.available === 'false' || variant.available === 0) {
            return true;
          }
          return false;
        }

        _footwearOptionValueKey(value) {
          return String(value == null ? '' : value)
            .trim()
            .replace(/\s+/g, ' ');
        }

        async _primeFootwearCachedProduct() {
          if (this._footwearCachedProduct) {
            return;
          }
          const handle = this.dataset.initialProductHandle;
          if (!handle) {
            return;
          }
          try {
            const res = await fetch(
              `${window.location.origin}/products/${handle}.json`
            );
            if (!res.ok) {
              return;
            }
            const data = await res.json();
            if (data && data.product) {
              this._footwearCachedProduct = data.product;
            }
          } catch (_e) {
            /* ignore */
          }
        }

        _footwearVariantOptionValue(variant, position) {
          if (!variant) {
            return undefined;
          }
          const p = Number(position, 10);
          if (Array.isArray(variant.options)) {
            return variant.options[p - 1];
          }
          return variant[`option${p}`];
        }

        _unbindFootwearDrawer() {
          if (!this._footwearDrawerBound) {
            return;
          }
          this.removeEventListener('click', this._onFootwearDrawerClick);
          this.removeEventListener('change', this._onFootwearDrawerChange);
          this._footwearDrawerBound = false;
          this._onFootwearDrawerClick = null;
          this._onFootwearDrawerChange = null;
        }

        _footwearReadConversionOffsets() {
          const script = this.querySelector(
            '[data-footwear-size-conversion]'
          );
          let src = {};
          if (script && script.textContent.trim()) {
            try {
              const parsed = JSON.parse(script.textContent);
              if (
                parsed != null &&
                typeof parsed === 'object' &&
                !Array.isArray(parsed)
              ) {
                src = parsed;
              }
            } catch (_e) {
              src = {};
            }
          }
          const parseOff = (value, fallback) => {
            if (value === null || value === undefined || value === '') {
              return fallback;
            }
            const n = Number(value);
            return Number.isFinite(n) ? n : fallback;
          };
          return {
            eu: parseOff(src.eu_offset, SIZE_CONVERSION_DEFAULTS.eu),
            us: parseOff(src.us_offset, SIZE_CONVERSION_DEFAULTS.us),
          };
        }

        _footwearFormatSizeValue(value) {
          if (value === null || value === undefined || value === '') {
            return '';
          }
          const numeric = Number(value);
          if (Number.isNaN(numeric)) {
            return String(value);
          }
          return Number.isInteger(numeric)
            ? `${numeric}`
            : numeric.toFixed(1).replace(/\.0$/, '');
        }

        _footwearExtractUkSizeFromVariant(variant) {
          const sources = [];
          if (Array.isArray(variant.options)) {
            sources.push(...variant.options);
          } else {
            ['option1', 'option2', 'option3'].forEach((k) => {
              if (variant[k]) {
                sources.push(variant[k]);
              }
            });
          }
          if (variant.title) {
            sources.push(variant.title);
          }
          if (variant.sku) {
            sources.push(variant.sku);
          }
          const joined = sources.join(' | ');
          const ukMatch = joined.match(/UK[\s:-]*([0-9]+(?:\.[0-9])?)/i);
          if (ukMatch) {
            return ukMatch[1];
          }
          const titleParts = String(variant.title || '').split(' / ');
          const candidate = titleParts[titleParts.length - 1] || '';
          const numericMatch = candidate.match(/([0-9]+(?:\.[0-9])?)/);
          if (numericMatch) {
            return numericMatch[1];
          }
          return '';
        }

        _footwearRegionLabelsForVariant(variant, offsets) {
          const ukSize = this._footwearExtractUkSizeFromVariant(variant);
          const defaultTitle =
            String(variant.title || '').split(' / ').pop() || '';
          const labels = { uk: '', eu: '', us: '' };
          if (!ukSize) {
            return {
              labels,
              fallback: defaultTitle,
            };
          }
          const numericUk = Number(ukSize);
          const hasNumericUk = !Number.isNaN(numericUk);
          const formattedUk = this._footwearFormatSizeValue(ukSize);
          labels.uk = formattedUk;
          if (hasNumericUk) {
            labels.eu = this._footwearFormatSizeValue(
              numericUk + offsets.eu
            );
            labels.us = this._footwearFormatSizeValue(
              numericUk + offsets.us
            );
          }
          return {
            labels,
            fallback: formattedUk || defaultTitle,
          };
        }

        _syncFootwearSizeRegionLabels(activeRegion) {
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          if (!footwear) {
            return;
          }
          const region = (activeRegion || 'uk').toLowerCase();
          footwear.querySelectorAll('.twa-product__option-list label').forEach((label) => {
            const span = label.querySelector('.twa-product__size-label-text');
            if (!span) {
              return;
            }
            const uk = label.dataset.showUk || '';
            const eu = label.dataset.showEu || '';
            const us = label.dataset.showUs || '';
            const text =
              region === 'eu'
                ? eu || uk || span.textContent
                : region === 'us'
                  ? us || uk || span.textContent
                  : uk || span.textContent;
            span.textContent = text;
          });
        }

        _applyFootwearLabelDatasetsFromVariants(product) {
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          if (!footwear || !product || !Array.isArray(product.variants)) {
            return;
          }
          const offsets = this._footwearReadConversionOffsets();
          const sizeOpt = (product.options || []).find((o) =>
            /size/i.test(String(o.name || ''))
          );
          if (!sizeOpt) {
            return;
          }
          const pos = Number(sizeOpt.position, 10) || 1;
          footwear.querySelectorAll('.twa-product__option-list label').forEach((label) => {
            const input = label.querySelector('input[type="radio"]');
            const raw = input && input.getAttribute('data-option-raw');
            if (!input || !raw) {
              return;
            }
            const rawKey = this._footwearOptionValueKey(raw);
            const variant = product.variants.find(
              (v) =>
                this._footwearOptionValueKey(
                  this._footwearVariantOptionValue(v, pos)
                ) === rawKey
            );
            if (!variant) {
              return;
            }
            const { labels, fallback } =
              this._footwearRegionLabelsForVariant(variant, offsets);
            label.dataset.showUk = labels.uk || fallback;
            label.dataset.showEu = labels.eu || labels.uk || fallback;
            label.dataset.showUs = labels.us || labels.uk || fallback;
          });
          const activeBtn = footwear.querySelector(
            '.twa-product__size-region-switcher-button.twa-region_active'
          );
          const reg = activeBtn && activeBtn.dataset.region
            ? activeBtn.dataset.region
            : 'uk';
          this._syncFootwearSizeRegionLabels(reg);
        }

        async _hydrateFootwearSwatchesFromCollection() {
          const model = this.dataset.footwearModel;
          if (!model) {
            return;
          }
          const list = this.querySelector(
            '[data-footwear-swatch-list]'
          );
          if (!list) {
            return;
          }
          if (list.querySelector('button[data-product-handle]')) {
            return;
          }
          this._setFootwearSwatchListLoading(list, true);
          try {
            const url =
              `${window.location.origin}/collections/all` +
              `?view=twa-swatch-search&filter.p.m.meta.product_model=${encodeURIComponent(model)}`;
            const res = await fetch(url);
            if (!res.ok) {
              return;
            }
            const doc = new DOMParser().parseFromString(
              await res.text(),
              'text/html'
            );
            const container = doc.querySelector('.twa-product-swatch-container');
            if (!container) {
              return;
            }
            const links = Array.from(
              container.querySelectorAll('a[data-product-handle]')
            );
            if (!links.length) {
              return;
            }
            const current = this.dataset.initialProductHandle || '';
            const frag = document.createDocumentFragment();
            const rows = [];
            links.forEach((link) => {
              const handle = link.getAttribute('data-product-handle');
              if (!handle) {
                return;
              }
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.setAttribute('data-color-switcher', '');
              btn.dataset.productHandle = handle;
              btn.className = 'twa-product__color-switcher-button';
              if (handle === current) {
                btn.classList.add('twa-product__color-swatchactive');
              }
              const img = link.querySelector('img');
              if (img) {
                btn.appendChild(img.cloneNode(true));
              }
              frag.appendChild(btn);
              rows.push(handle);
            });
            list.innerHTML = '';
            list.appendChild(frag);
            const idResults = await Promise.all(
              rows.map((handle) =>
                fetch(`${window.location.origin}/products/${handle}.json`)
                  .then((r) => (r.ok ? r.json() : null))
                  .then((d) =>
                    d && d.product ? { handle, id: d.product.id } : null
                  )
                  .catch(() => null)
              )
            );
            idResults.forEach((row) => {
              if (!row) {
                return;
              }
              const btn = Array.from(
                list.querySelectorAll('button[data-product-handle]')
              ).find((b) => b.dataset.productHandle === row.handle);
              if (btn) {
                btn.dataset.productId = String(row.id);
              }
            });
          } catch (_err) {
            /* ignore */
          } finally {
            this._setFootwearSwatchListLoading(list, false);
          }
        }

        async _swapDrawerProductdetailsViaView(handle) {
          const safeHandle = String(handle || '').trim();
          if (!safeHandle) {
            return false;
          }
          const url =
            `${window.location.origin}/products/${encodeURIComponent(safeHandle)}` +
            `?view=twa-variant-drawer`;
          try {
            const res = await fetch(url, { credentials: 'same-origin' });
            if (!res.ok) {
              return false;
            }
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const incoming = doc.querySelector('.twa-variant__drawer-productdetails');
            if (!incoming) {
              return false;
            }
            const current = this.querySelector('.twa-variant__drawer-productdetails');
            if (!current) {
              return false;
            }

            const incomingType = incoming.getAttribute('data-drawer-product-type');

            // Clothing only: size guide lives outside `.twa-variant__drawer-productdetails`.
            // Swap it from the fetched HTML so `data-modal` / content match the colour.
            if (incomingType === 'clothing') {
              const currentSg = this.querySelector(
                '.twa-sidemodal-outercontainer.twa-sidemodal-sizeguide[id^="twasizeguideclothing-"]'
              );
              const incomingSg = doc.querySelector(
                '.twa-sidemodal-outercontainer.twa-sidemodal-sizeguide[id^="twasizeguideclothing-"]'
              );
              if (currentSg && incomingSg) {
                currentSg.replaceWith(document.importNode(incomingSg, true));
              } else if (currentSg && !incomingSg) {
                currentSg.remove();
              } else if (!currentSg && incomingSg) {
                this.appendChild(document.importNode(incomingSg, true));
              }
            }

            current.replaceWith(document.importNode(incoming, true));
            this._unbindTriggers();
            this._bindTriggers();

            const nextHandle = incoming.getAttribute('data-drawer-product-handle');
            const nextId = incoming.getAttribute('data-drawer-product-id');
            if (nextHandle) {
              this.dataset.initialProductHandle = nextHandle;
            } else {
              this.dataset.initialProductHandle = safeHandle;
            }
            if (nextId) {
              this.dataset.initialProductId = nextId;
            }

            const type = incomingType;
            if (type === 'footwear') {
              const model = incoming.getAttribute('data-drawer-footwear-model');
              if (model) {
                this.dataset.footwearModel = model;
              }
              this._footwearCachedProduct = null;
              await this._primeFootwearCachedProduct();
              if (this._footwearCachedProduct) {
                this._applyFootwearLabelDatasetsFromVariants(this._footwearCachedProduct);
                this._updateFootwearSelectionFromRadios();
              }
            } else if (type === 'clothing') {
              this._clothingCachedProduct = null;
              await this._primeClothingCachedProduct();
              if (this._clothingCachedProduct) {
                this._updateClothingSelectionFromRadios();
              }
            }

            this._productMediaDragBound = false;
            this._unbindProductMediaDragScroll();
            this._bindProductMediaDragScroll();            

            return true;
          } catch (_err) {
            return false;
          }
        }

        _handleFootwearDrawerClick(e) {
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          if (!footwear || !this.contains(e.target)) {
            return;
          }
          const colorBtn = e.target.closest('[data-color-switcher]');
          if (colorBtn && footwear.contains(colorBtn)) {
            e.preventDefault();
            e.stopPropagation();
            const handle = colorBtn.dataset.productHandle;
            if (!handle) {
              return;
            }
            void (async () => {
              const swapped = await this._swapDrawerProductdetailsViaView(handle);
              if (!swapped) {
                this._switchFootwearProductByHandle(handle, colorBtn);
              }
            })();
            return;
          }
          const regionBtn = e.target.closest(
            '.twa-product__size-region-switcher-button[data-region]'
          );
          if (regionBtn && footwear.contains(regionBtn)) {
            e.preventDefault();
            e.stopPropagation();
            const region = regionBtn.dataset.region || 'uk';
            footwear
              .querySelectorAll('.twa-product__size-region-switcher-button')
              .forEach((b) => {
                b.classList.toggle('twa-region_active', b === regionBtn);
              });
            void (async () => {
              await this._primeFootwearCachedProduct();
              const p = this._footwearCachedProduct;
              if (p) {
                this._applyFootwearLabelDatasetsFromVariants(p);
              }
              this._syncFootwearSizeRegionLabels(region);
            })();
          }
        }

        _handleFootwearDrawerChange(e) {
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          if (!footwear || !footwear.contains(e.target)) {
            return;
          }
          const input = e.target;
          if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') {
            return;
          }
          this._updateFootwearSelectionFromRadios();
        }

        _updateFootwearSelectionFromRadios() {
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          const script = footwear && footwear.querySelector(
            'script[data-product-variants]'
          );
          if (!footwear || !script) {
            return;
          }
          const product = this._footwearCachedProduct;
          if (!product || !Array.isArray(product.variants)) {
            return;
          }
          const checked = footwear.querySelector(
            '.twa-product__option-list input[type="radio"]:checked'
          );
          if (!checked) {
            return;
          }
          const raw = checked.getAttribute('data-option-raw');
          const name = checked.getAttribute('name');
          let sizeOpt = (product.options || []).find(
            (o) => String(o.name) === String(name)
          );
          if (!sizeOpt) {
            sizeOpt = (product.options || []).find((o) =>
              /size/i.test(String(o.name || ''))
            );
          }
          if (!sizeOpt) {
            return;
          }
          const pos = Number(sizeOpt.position, 10) || 1;
          const rawKey = this._footwearOptionValueKey(raw);
          const variant = product.variants.find(
            (v) =>
              this._footwearOptionValueKey(
                this._footwearVariantOptionValue(v, pos)
              ) === rawKey
          );
          if (!variant) {
            return;
          }
          const atc = this.querySelector('[data-add-to-cart]');
          if (atc) {
            atc.setAttribute('data-product-id', String(variant.id));
          }
          const priceEl = this.querySelector('.twa-variant__drawer-price');

          if (priceEl && variant.price != null) {
            const cur = this.dataset.currencyCode || 'GBP';
            const loc = this.dataset.moneyLocale || undefined;
            try {
              priceEl.textContent = new Intl.NumberFormat(loc, {
                style: 'currency',
                currency: cur,
              }).format(Number(variant.price));
            } catch (_e2) {
              priceEl.textContent = (Number(variant.price) / 100).toFixed(2);
            }
          }
          footwear.querySelectorAll('.twa-product__option-list label').forEach((lab) => {
            lab.classList.remove('active');
          });
          const lab = checked.closest('label');
          if (lab) {
            lab.classList.add('active');
          }
          this._syncDrawerAtcButtonState(product, variant);
        }

        async _switchFootwearProductByHandle(handle, colorBtn) {
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          if (!footwear) {
            return;
          }
          const list = footwear.querySelector('[data-footwear-swatch-list]');
          this._setFootwearSwatchListLoading(list, true);
          try {
            const res = await fetch(
              `${window.location.origin}/products/${handle}.json`
            );
            if (!res.ok) {
              return;
            }
            const { product } = await res.json();
            this._footwearCachedProduct = product;
            const list = footwear.querySelector('[data-footwear-swatch-list]');
            const activeHandle =
              (colorBtn && colorBtn.dataset.productHandle) || handle;
            if (list) {
              list
                .querySelectorAll('.twa-product__color-switcher-button')
                .forEach((b) => {
                  b.classList.toggle(
                    'twa-product__color-swatchactive',
                    b.dataset.productHandle === activeHandle
                  );
                });
            }
            const modelStr = String(this.dataset.footwearModel || '');
            const title = product.title || '';
            const colour = modelStr
              ? title.replace(modelStr, '').trim()
              : title;
            const headColor = this.querySelector(
              '.twa-variant__drawer-swatchcolor'
            );
            const footColor = footwear.querySelector('[data-selected-color]');
            if (headColor) {
              headColor.textContent = colour;
            }
            if (footColor) {
              footColor.textContent = colour;
            }
            const h3 = this.querySelector('.twa-variant__drawer-productheader h3');
            if (h3) {
              h3.textContent = title;
            }
            const vScript = footwear.querySelector(
              'script[data-product-variants]'
            );
            if (vScript) {
              vScript.textContent = JSON.stringify(product.variants || []);
            }
            const convScript = footwear.querySelector(
              '[data-footwear-size-conversion]'
            );
            if (convScript) {
              const mf = product.metafields || {};
              const custom = mf.custom || {};
              const sc = custom.size_conversion;
              const val =
                sc && typeof sc === 'object' && 'value' in sc ? sc.value : sc;
              convScript.textContent = JSON.stringify(val || {});
            }
            this._rebuildFootwearSizeOptionList(product);
            this._applyFootwearLabelDatasetsFromVariants(product);
            this._rebuildDrawerProductMedia(product);
            const view = this.querySelector('[data-drawer-view-product]');
            if (view && product.handle) {
              const href =
                product.url && String(product.url).startsWith('/')
                  ? String(product.url)
                  : `/products/${product.handle}`;
              view.setAttribute('href', href);
            }
            this.dataset.initialProductHandle = handle;
            if (product.id) {
              this.dataset.initialProductId = String(product.id);
            }
            const soldOutTag = this._footwearHasProductTag(
              product,
              'sold-out'
            );
            const pick =
              (product.variants || []).find(
                (v) =>
                  !this._footwearVariantExplicitlyUnavailable(v) && !soldOutTag
              ) ||
              (product.variants || [])[0];
            if (pick) {
              const atc = this.querySelector('[data-add-to-cart]');
              if (atc) {
                atc.setAttribute('data-product-id', String(pick.id));
              }
              this._syncDrawerAtcButtonState(product, pick);
            }
            footwear
              .querySelectorAll('.twa-product__size-region-switcher-button')
              .forEach((b, i) => {
                b.classList.toggle('twa-region_active', i === 0);
              });
            this._updateFootwearSelectionFromRadios();
            this._syncFootwearSizeRegionLabels('uk');
          } catch (_err) {
            /* ignore */
          } finally {
            this._setFootwearSwatchListLoading(list, false);
          }
        }

        _rebuildFootwearSizeOptionList(product) {
          const footwear = this.querySelector('.twa-product__swatch-footwear');
          if (!footwear || !product || !Array.isArray(product.options)) {
            return;
          }
          const opt = product.options.find((o) =>
            /size/i.test(String(o.name || ''))
          );
          const holder = footwear.querySelector('.twa-product__swatch-picker-option');
          if (!opt || !holder || !Array.isArray(opt.values)) {
            return;
          }
          const optName = opt.name || 'Size';
          const position = Number(opt.position, 10) || 1;
          const listEl = holder.querySelector('.twa-product__option-list');
          if (!listEl) {
            return;
          }
          const soldOut = this._footwearHasProductTag(product, 'sold-out');
          const selected =
            (product.variants || []).find(
              (v) =>
                !this._footwearVariantExplicitlyUnavailable(v) && !soldOut
            ) ||
            (product.variants || [])[0];
          const selectedRaw = selected
            ? this._footwearVariantOptionValue(selected, position)
            : null;

          listEl.innerHTML = '';
          opt.values.forEach((value, idx) => {
            const raw = String(value);
            const rawKey = this._footwearOptionValueKey(raw);
            const variant = (product.variants || []).find(
              (v) =>
                this._footwearOptionValueKey(
                  this._footwearVariantOptionValue(v, position)
                ) === rawKey
            );
            let availability = variant
              ? !this._footwearVariantExplicitlyUnavailable(variant)
              : true;
            if (soldOut) {
              availability = false;
            }
            const idSlug = `twa-drawer-size-${position}-${idx}`;
            const lab = document.createElement('label');
            lab.htmlFor = idSlug;
            if (!availability) {
              lab.classList.add('out-stock');
            }
            const span = document.createElement('span');
            span.className = 'twa-product__size-label-text';
            span.textContent = raw.split('UK').join('').trim();
            const inp = document.createElement('input');
            inp.type = 'radio';
            inp.name = optName;
            inp.value = raw
              .toLowerCase()
              .trim()
              .replace(/\s+/g, '-')
              .replace(/[^a-z0-9-]/g, '');
            inp.id = idSlug;
            inp.setAttribute('data-option-raw', raw);
            if (
              selectedRaw != null &&
              this._footwearOptionValueKey(selectedRaw) === rawKey
            ) {
              inp.checked = true;
              lab.classList.add('active');
            }
            lab.appendChild(span);
            lab.appendChild(inp);
            listEl.appendChild(lab);
          });
        }

        async _maybeInitClothingDrawer() {
          const clothing = this.querySelector('.twa-product__swatch-clothing');
          if (!clothing || this.dataset.clothingDrawer !== 'true') {
            return;
          }
          if (this._clothingDrawerBound) {
            return;
          }
          this._clothingDrawerBound = true;
          this._onClothingDrawerClick = (e) => {
            this._handleClothingDrawerClick(e);
          };
          this._onClothingDrawerChange = (e) => {
            this._handleClothingDrawerChange(e);
          };
          this.addEventListener('click', this._onClothingDrawerClick);
          this.addEventListener('change', this._onClothingDrawerChange);
          await this._primeClothingCachedProduct();
          if (this._clothingCachedProduct) {
            const p = this._clothingCachedProduct;
            const soldOut = this._footwearHasProductTag(p, 'sold-out');
            const v =
              (p.variants || []).find(
                (x) =>
                  !this._footwearVariantExplicitlyUnavailable(x) && !soldOut
              ) ||
              (p.variants || [])[0];
            if (v) {
              this._syncDrawerAtcButtonState(p, v);
            }
          }
        }

        async _primeClothingCachedProduct() {
          if (this._clothingCachedProduct) {
            return;
          }
          const handle = this.dataset.initialProductHandle;
          if (!handle) {
            return;
          }
          try {
            const res = await fetch(
              `${window.location.origin}/products/${handle}.json`
            );
            if (!res.ok) {
              return;
            }
            const data = await res.json();
            if (data && data.product) {
              this._clothingCachedProduct = data.product;
            }
          } catch (_e) {
            /* ignore */
          }
        }

        _unbindClothingDrawer() {
          if (!this._clothingDrawerBound) {
            return;
          }
          this.removeEventListener('click', this._onClothingDrawerClick);
          this.removeEventListener('change', this._onClothingDrawerChange);
          this._clothingDrawerBound = false;
          this._onClothingDrawerClick = null;
          this._onClothingDrawerChange = null;
        }

        /**
         * Matches Liquid size labels in twa-drawer-product-clothing.liquid.
         */
        _clothingDisplayLabelForCode(raw) {
          if (raw == null || raw === '') {
            return '';
          }
          const key = String(raw).trim().toUpperCase();
          const map = {
            XXXS: 'XXXSmall',
            XXS: 'XXSmall',
            XS: 'XSmall',
            S: 'Small',
            M: 'Medium',
            L: 'Large',
            XL: 'XLarge',
            XXL: 'XXLarge',
            '2XL': 'XXLarge',
            XXXL: 'XXXLarge',
            '3XL': 'XXXLarge',
            '4XL': 'XXXXLarge',
            '5XL': 'XXXXXLarge',
            OS: 'One Size',
            'O/S': 'One Size',
            'ONE SIZE': 'One Size',
            ONESIZE: 'One Size',
          };
          return Object.prototype.hasOwnProperty.call(map, key)
            ? map[key]
            : String(raw).trim();
        }

        _clothingProductViewHref(product) {
          if (!product || !product.handle) {
            return '';
          }
          const base =
            product.url && String(product.url).startsWith('/')
              ? String(product.url)
              : `/products/${product.handle}`;
          if (base.includes('?')) {
            return `${base}&view=clothing`;
          }
          return `${base}?view=clothing`;
        }

        _handleClothingDrawerClick(e) {
          const clothing = this.querySelector('.twa-product__swatch-clothing');
          if (!clothing || !this.contains(e.target)) {
            return;
          }
          const colorBtn = e.target.closest('[data-color-switcher]');
          if (colorBtn && clothing.contains(colorBtn)) {
            e.preventDefault();
            e.stopPropagation();
            const handle = colorBtn.dataset.productHandle;
            if (!handle) {
              return;
            }
            void (async () => {
              const swapped = await this._swapDrawerProductdetailsViaView(handle);
              if (!swapped) {
                this._switchClothingProductByHandle(handle, colorBtn);
              }
            })();
          }
        }

        _handleClothingDrawerChange(e) {
          const clothing = this.querySelector('.twa-product__swatch-clothing');
          if (!clothing || !clothing.contains(e.target)) {
            return;
          }
          const input = e.target;
          if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') {
            return;
          }
          this._updateClothingSelectionFromRadios();
        }

        _updateClothingSelectionFromRadios() {
          const clothing = this.querySelector('.twa-product__swatch-clothing');
          const script = clothing && clothing.querySelector(
            'script[data-product-variants]'
          );
          if (!clothing || !script) {
            return;
          }
          const product = this._clothingCachedProduct;
          if (!product || !Array.isArray(product.variants)) {
            return;
          }
          const checked = clothing.querySelector(
            '.twa-product__option-list input[type="radio"]:checked'
          );
          if (!checked) {
            return;
          }
          const raw = checked.getAttribute('data-option-raw');
          const name = checked.getAttribute('name');
          let sizeOpt = (product.options || []).find(
            (o) => String(o.name) === String(name)
          );
          if (!sizeOpt) {
            sizeOpt = (product.options || []).find((o) =>
              /size/i.test(String(o.name || ''))
            );
          }
          if (!sizeOpt) {
            return;
          }
          const pos = Number(sizeOpt.position, 10) || 1;
          const rawKey = this._footwearOptionValueKey(raw);
          const variant = product.variants.find(
            (v) =>
              this._footwearOptionValueKey(
                this._footwearVariantOptionValue(v, pos)
              ) === rawKey
          );
          if (!variant) {
            return;
          }
          const atc = this.querySelector('[data-add-to-cart]');
          if (atc) {
            atc.setAttribute('data-product-id', String(variant.id));
          }
          const priceEl = this.querySelector('.twa-variant__drawer-price');
          if (priceEl && variant.price != null) {
            const cur = this.dataset.currencyCode || 'GBP';
            const loc = this.dataset.moneyLocale || undefined;
            try {
              priceEl.textContent = new Intl.NumberFormat(loc, {
                style: 'currency',
                currency: cur,
              }).format(Number(variant.price));
            } catch (_e2) {
              priceEl.textContent = (Number(variant.price) / 100).toFixed(2);
            }
          }
          const sizeLine = clothing.querySelector('[data-selected-size]');
          if (sizeLine && raw != null) {
            sizeLine.textContent = this._clothingDisplayLabelForCode(raw);
            sizeLine.setAttribute('data-size-code', String(raw).trim());
          }
          clothing.querySelectorAll('.twa-product__option-list label').forEach(
            (lab) => {
              lab.classList.remove('active');
            }
          );
          const lab = checked.closest('label');
          if (lab) {
            lab.classList.add('active');
          }
          this._syncDrawerAtcButtonState(product, variant);
        }

        async _switchClothingProductByHandle(handle, colorBtn) {
          const clothing = this.querySelector('.twa-product__swatch-clothing');
          if (!clothing) {
            return;
          }
          try {
            const res = await fetch(
              `${window.location.origin}/products/${handle}.json`
            );
            if (!res.ok) {
              return;
            }
            const { product } = await res.json();
            this._clothingCachedProduct = product;
            const list = clothing.querySelector('[data-clothing-swatch-list]');
            const activeHandle =
              (colorBtn && colorBtn.dataset.productHandle) || handle;
            let resolvedColorBtn = colorBtn;
            if (!resolvedColorBtn && list && handle) {
              resolvedColorBtn = Array.from(
                list.querySelectorAll('button[data-product-handle]')
              ).find((b) => b.dataset.productHandle === handle);
            }
            if (list) {
              list
                .querySelectorAll('.twa-product__color-switcher-button')
                .forEach((b) => {
                  b.classList.toggle(
                    'twa-product__color-swatchactive',
                    b.dataset.productHandle === activeHandle
                  );
                });
            }
            const colorFromBtn =
              resolvedColorBtn && resolvedColorBtn.dataset.clothingColor
                ? resolvedColorBtn.dataset.clothingColor
                : '';
            const title = product.title || '';
            const headColor = this.querySelector(
              '.twa-variant__drawer-swatchcolor'
            );
            const footColor = clothing.querySelector('[data-selected-color]');
            const colorText = colorFromBtn || title;
            if (headColor) {
              headColor.textContent = colorText;
            }
            if (footColor) {
              footColor.textContent = colorText;
            }
            const h3 = this.querySelector('.twa-variant__drawer-productheader h3');
            if (h3) {
              h3.textContent = title;
            }
            const vScript = clothing.querySelector(
              'script[data-product-variants]'
            );
            if (vScript) {
              vScript.textContent = JSON.stringify(product.variants || []);
            }
            this._rebuildClothingSizeOptionList(product);
            this._rebuildDrawerProductMedia(product);
            const view = this.querySelector('[data-drawer-view-product]');
            if (view && product.handle) {
              view.setAttribute('href', this._clothingProductViewHref(product));
            }
            this.dataset.initialProductHandle = handle;
            if (product.id) {
              this.dataset.initialProductId = String(product.id);
            }
            const soldOutTag = this._footwearHasProductTag(
              product,
              'sold-out'
            );
            const pick =
              (product.variants || []).find(
                (v) =>
                  !this._footwearVariantExplicitlyUnavailable(v) && !soldOutTag
              ) ||
              (product.variants || [])[0];
            if (pick) {
              const atc = this.querySelector('[data-add-to-cart]');
              if (atc) {
                atc.setAttribute('data-product-id', String(pick.id));
              }
              this._syncDrawerAtcButtonState(product, pick);
            }
            this._updateClothingSelectionFromRadios();
          } catch (_err) {
            /* ignore */
          }
        }

        _rebuildClothingSizeOptionList(product) {
          const clothing = this.querySelector('.twa-product__swatch-clothing');
          if (!clothing || !product || !Array.isArray(product.options)) {
            return;
          }
          const opt = product.options.find((o) =>
            /size/i.test(String(o.name || ''))
          );
          const holder = clothing.querySelector('.twa-product__swatch-picker-option');
          if (!opt || !holder || !Array.isArray(opt.values)) {
            return;
          }
          const optName = opt.name || 'Size';
          const position = Number(opt.position, 10) || 1;
          const listEl = holder.querySelector('.twa-product__option-list');
          if (!listEl) {
            return;
          }
          const soldOut = this._footwearHasProductTag(product, 'sold-out');
          const selected =
            (product.variants || []).find(
              (v) =>
                !this._footwearVariantExplicitlyUnavailable(v) && !soldOut
            ) ||
            (product.variants || [])[0];
          const selectedRaw = selected
            ? this._footwearVariantOptionValue(selected, position)
            : null;

          listEl.innerHTML = '';
          opt.values.forEach((value, idx) => {
            const raw = String(value);
            const rawKey = this._footwearOptionValueKey(raw);
            const variant = (product.variants || []).find(
              (v) =>
                this._footwearOptionValueKey(
                  this._footwearVariantOptionValue(v, position)
                ) === rawKey
            );
            let availability = variant
              ? !this._footwearVariantExplicitlyUnavailable(variant)
              : true;
            if (soldOut) {
              availability = false;
            }
            const idSlug = `twa-drawer-clothing-size-${position}-${idx}`;
            const lab = document.createElement('label');
            lab.htmlFor = idSlug;
            if (!availability) {
              lab.classList.add('twa-product__option-soldout');
            }
            const span = document.createElement('span');
            span.className = 'twa-product__size-label-text';
            span.textContent = raw.split('UK').join('').trim();
            const inp = document.createElement('input');
            inp.type = 'radio';
            inp.name = optName;
            inp.value = raw
              .toLowerCase()
              .trim()
              .replace(/\s+/g, '-')
              .replace(/[^a-z0-9-]/g, '');
            inp.id = idSlug;
            inp.setAttribute('data-option-raw', raw);
            if (!availability) {
              inp.disabled = true;
            }
            if (
              selectedRaw != null &&
              this._footwearOptionValueKey(selectedRaw) === rawKey
            ) {
              inp.checked = true;
              lab.classList.add('active');
            }
            lab.appendChild(span);
            lab.appendChild(inp);
            listEl.appendChild(lab);
          });
          const sizeLine = clothing.querySelector('[data-selected-size]');
          if (sizeLine && selectedRaw != null) {
            sizeLine.textContent =
              this._clothingDisplayLabelForCode(selectedRaw);
            sizeLine.setAttribute(
              'data-size-code',
              String(selectedRaw).trim()
            );
          }
        }

        _rebuildDrawerProductMedia(product) {
          const wrap = this.querySelector('.twa-variant__drawer-productmedia');
          if (!wrap || !product) {
            return;
          }
          let images = product.images || [];
          if (!images.length && product.featured_image) {
            images = [product.featured_image];
          }
          if (!images.length) {
            return;
          }
          wrap.innerHTML = '';
          images.forEach((im) => {
            const src = typeof im === 'string' ? im : im.src;
            if (!src) {
              return;
            }
            const row = document.createElement('div');
            row.className = 'twa-variant__drawer-productmedia-item';
            const img = document.createElement('img');
            const q = String(src).includes('?') ? '&' : '?';
            img.src = `${src}${q}width=720`;
            img.alt = '';
            img.loading = 'lazy';
            row.appendChild(img);
            wrap.appendChild(row);
          });
          this._productMediaDragBound = false;
          this._unbindProductMediaDragScroll();
          this._bindProductMediaDragScroll();
        }

        _unbindProductMediaDragScroll() {
          if (typeof this._productMediaDragCleanup === 'function') {
            this._productMediaDragCleanup();
          }
        }
      }
    );
  }
  
  /**
   * Size guide / side modals: use event delegation so buttons work after AJAX,
   * Section Rendering, or any injected HTML (no per-element listeners).
   */
  function closeAllSizeSubmodals() {
    document.querySelectorAll('.twa-sizemodalsub-outer').forEach((submodal) => {
      submodal.classList.remove('twa-sizemodalsub-outer-active');
    });
  }

  document.addEventListener(
    'click',
    (e) => {
      const openBtn = e.target.closest('.twa-sidemodal-btn');
      if (openBtn) {
        if (
          typeof window.__twaSuppressSidemodalOpenUntil === 'number' &&
          Date.now() < window.__twaSuppressSidemodalOpenUntil
        ) {
          return;
        }

        const modalId = openBtn.dataset.modal;
        const modal = modalId ? document.getElementById(modalId) : null;
        if (!modal) {
          return;
        }
        const tabId = openBtn.dataset.tab;
        const tab = tabId ? document.getElementById(tabId) : null;
        modal.classList.add('twa-sidemodal-active');
        document.body.classList.add('twa-sidemodal-opened');
        if (tab) {
          tab.click();
        }
        return;
      }

      const overlay = e.target.closest('.twa-sidemodal-overlay');
      if (overlay) {
        const parent = overlay.parentElement;
        if (parent) {
          parent.classList.remove('twa-sidemodal-active');
        }
        document.body.classList.remove('twa-sidemodal-opened');
        closeAllSizeSubmodals();
        return;
      }

      // Before `.twa-sidemodals-header button`: the close control is also a
      // header button; without this order, tab logic runs first and returns
      // early when `data-tab` is missing, so close never runs.
      const closeBtn = e.target.closest('.twa-sidemodal-btnclose');
      if (closeBtn) {
        const closeId = closeBtn.dataset.close;
        const modal = closeId ? document.getElementById(closeId) : null;
        if (modal) {
          modal.classList.remove('twa-sidemodal-active');
        }
        document.body.classList.remove('twa-sidemodal-opened');
        closeAllSizeSubmodals();
        return;
      }

      const headerBtn = e.target.closest(
        '.twa-sidemodals-header button:not(.twa-sidemodal-btnclose)'
      );
      if (headerBtn) {
        const tabId = headerBtn.dataset.tab;
        if (!tabId) {
          return;
        }
        const tab = document.getElementById(tabId);
        if (!tab) {
          return;
        }
        document
          .querySelectorAll(
            '.twa-sidemodals-header button:not(.twa-sidemodal-btnclose)'
          )
          .forEach((btn) => {
            btn.classList.remove('twa-tabactive');
          });
        headerBtn.classList.add('twa-tabactive');
        document.querySelectorAll('.twa-tabactivecontents').forEach((activeTab) => {
          activeTab.classList.remove('twa-tabactivecontents');
        });
        tab.classList.add('twa-tabactivecontents');
        return;
      }

      const innerBtn = e.target.closest('.twa-sizemodalinner-btn');
      if (innerBtn) {
        const subId = innerBtn.dataset.submodal;
        const submodal = subId ? document.getElementById(subId) : null;
        if (submodal) {
          submodal.classList.add('twa-sizemodalsub-outer-active');
        }
        return;
      }

      const backBtn = e.target.closest('.twa-sizemodalsub-back');
      if (backBtn) {
        const subId = backBtn.dataset.submodal;
        const submodal = subId ? document.getElementById(subId) : null;
        if (submodal) {
          submodal.classList.remove('twa-sizemodalsub-outer-active');
        }
      }
    },
    false
  );

  document.addEventListener('DOMContentLoaded', () => {
    new VariantPicker();
  });
